export const PAYMENT_STATUS = {
  UNKNOWN: 'UNKNOWN',
  OPEN: 'OPEN',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
}

export const PRE_ORDER_TYPE = {
  SINGLE: 'SINGLE',
  ALL: 'ALL',
  SERIES: 'SERIES',
}

export const PRE_ORDER_TYPE_LABEL = {
  [PRE_ORDER_TYPE.SINGLE]: 'เดี่ยว',
  [PRE_ORDER_TYPE.ALL]: 'ผสม',
  [PRE_ORDER_TYPE.SERIES]: 'ชุด',
}

export const UNASSIGNED_TIME = '0001-01-01T00:00:00Z'

export const INITIAL_SEARCH_PARAMS = {
  status: PAYMENT_STATUS.UNKNOWN,
  userId: '',
  sort: 'ASC',
  firstName: '',
  lastName: '',
  userNo: '',
  number: '',
  orderNo: '',
  page: 1,
  limit: 20,
  phoneNo: '',
}
